import script from "./VoiceContributionInput.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceContributionInput.vue?vue&type=script&setup=true&lang=js"

import "./VoiceContributionInput.vue?vue&type=style&index=0&id=0a64574d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a64574d"]])

export default __exports__